import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getVouchers } from '../actions/VoucherActions';
import DataTable from '../../common/DataTable/DataTable';
import { Link } from 'react-router-dom';
import { Button, Pane } from 'evergreen-ui';

class ListVouchers extends Component {
    handleTableChange = (opts) => {
        this.props.dispatch(getVouchers(opts));
    }

    render() {
        return (<>
            <Pane display="flex" marginBottom={16}>
                <Pane>
                    <Link to="/vouchers/create">
                        <Button iconBefore="add" intent="none" appearance="primary">
                            Voucher Nou
                        </Button>
                    </Link>
                </Pane>
            </Pane>
            <DataTable
                defaultFilter='id'
                defaultDirection='desc'
                columns={[
                    {id: 'id', label: 'Id'},
                    {id: 'name', label: 'Nume'},
                    {id: 'used', label: 'Folosit', decorator: 'boolean'},
                    {id: 'type', label: 'Tip'},
                    {id: 'isPercentage', label: 'Procentual', decorator: 'boolean'},
                    {id: 'value', label: 'Valoare'},
                    {id: 'unlimited', label: 'Nelimitat', decorator: 'boolean'},
                    {id: 'validTo', label:'Valabilitate', decorator: 'date'},
                    {id: 'createdAt', label: 'Creat', decorator: 'date'},
                    {id: 'updatedAt', label: 'Modificat', decorator: 'date'}
                ]}

                data={this.props.data}
                updateKey={this.props.data}
                page={this.props.page}
                pageSize={this.props.pageSize}
                pageCount={this.props.pageCount}
    

                onTableChange={this.handleTableChange}

                itemMenu={[
                    { getLink: (item) => `/vouchers/${item[0]}`, label: 'Detalii', icon: 'eye-open' },
                    { getLink: (item) => `/vouchers/${item[0]}/edit`, label: 'Editeaza', icon: 'edit' }
                ]}
            />
        </>)
    }
}

function mapStateToProps(state) {
    return state.vouchers;
}

export default connect(mapStateToProps)(ListVouchers);